<template>
  <div class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ $tc("note.questionnaire.title", 2) }}</h2>
    </div>
    <div class="widget-content">
      <div class="mark__list">
        <div v-for="(item, index) in marks" :key="index" class="mark__item">
          <div>{{ setProfileLabel(item.profile) }} :</div>
          <div class="fw-bold">{{ item.mark ? item.mark : "--" }}</div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button v-tooltip="{ title: $t('note.see_details') }" type="button" class="mark__button" @click="showDetail">
          <FontAwesomeIcon icon="fa-light fa-eye" class="me-1" />{{ $t("note.details") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
import { triadManager } from "@/services/triad/triad-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "QuestionnaireMarkBlockComponent",
  components: { FontAwesomeIcon },
  props: {
    marks: {
      type: Object,
      required: true,
    },
  },
  emits: ["showDetail"],
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
  },
  methods: {
    setProfileLabel(key) {
      return triadManager.setProfileLabel(
        key,
        this.apprenticeProfileLabel,
        this.tutorProfileLabel,
        this.apprenticeMasterProfileLabel,
        this.studeaManagerProfileLabel,
      );
    },

    showDetail() {
      this.$emit("showDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
.mark {
  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--primary-color);
    font-size: 15px;
  }

  &__mark {
    font-weight: 700;
    font-size: 0.875rem;
  }

  &__button {
    background-color: inherit;
    border: none;
    color: var(--primary-color);
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
